import _uniqBy from 'lodash/uniqBy';

export default {
  namespaced: true,

  state: {
    /** 최근 본 상품 목록 */
    recentGoods: [],
    /** 최근 검색어 목록
     * @type {{ keyword: string, time: number }[]}
     */
    recentKeywords: [],
  },

  mutations: {
    /**
     * @param {*} state
     * @param {string[]} list
     */
    ADD_RECENT_WORD: (state, list) => {
      state.recentKeywords = _uniqBy(
        [...list.filter((keyword) => Boolean(keyword?.trim())).map((keyword) => ({ keyword: keyword.trim(), time: Date.now() })), ...state.recentKeywords],
        'keyword',
      ).slice(0, 10);
    },
    REMOVE_RECENT_WORD: (state, keyword) => {
      state.recentKeywords = state.recentKeywords.filter((item) => item.keyword !== keyword.trim());
    },
    CLEAR_RECENT_WORD: (state) => {
      state.recentKeywords = [];
    },
  },

  actions: {
    addRecentKeywords({ commit }, item) {
      if (Array.isArray(item)) {
        commit('ADD_RECENT_WORD', item);
      } else {
        commit('ADD_RECENT_WORD', [item]);
      }
    },
    removeRecentKeywords({ commit }, keyword) {
      commit('REMOVE_RECENT_WORD', keyword);
    },
    clearRecentKeywords({ commit }) {
      commit('CLEAR_RECENT_WORD');
    },
  },

  getters: {
    recentGoods: (state) => state.recentGoods,
    recentKeywords: (state) => state.recentKeywords,
  },
};
